<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="false"
                        ></action-toolbar-buttons>
                        <div class="btn-group" *ngIf="canEdit">
                            <button type="button" class="btn btn-sm btn-secondary" (click)="deleteSelectedItem()" [disabled]="!grid.hasItemSelected">
                                <fa-icon class="d-none d-sm-inline-block" [icon]="faXmark"></fa-icon> Delete
                            </button>
                        </div>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Incident Investigations'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="incidentInvestigationGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Incident Date/Time'" [binding]="'incidentOn'" [format]="'g'" [width]="170" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Type'" [binding]="'incidentType'" [width]="110" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Location'" [binding]="'location'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Reporting Party'" [binding]="'reportingPartyUserId'" [dataMap]="reportingPartyMap" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobDisplay'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Supervisor'" [binding]="'supervisorUserId'" [dataMap]="supervisorMap" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Involved Employees'" [binding]="'involvedEmployeeNames'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Injury'" [binding]="'resultCausedInjury'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Submitted On'" [binding]="'submittedOn'" [format]="'g'" [width]="160" [isReadOnly]="true"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
